export default __webpack_public_path__ + "static/media/logo_full.77fb1169.png";